import React, { useCallback, useEffect, useState } from 'react'
import { useStyles } from './styles'
import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { getEditingNote, upsertNote, stopEditing } from 'redux/slices/showNotes'

export const NoteEditor = ({ showId }) => {
    const classes = useStyles()
    const note = useSelector(getEditingNote, shallowEqual)
    const dispatch = useDispatch()
    const [body, setBody] = useState('')

    useEffect(() => {
        setBody(note.body)
    }, [note])

    const saveNote = useCallback(() => {
        dispatch(upsertNote(showId, { ...note, body }))
    }, [body, note, showId, dispatch])

    const handleClosing = useCallback(() => {
        dispatch(stopEditing())
    }, [dispatch])

    return (
        <div className={classes.editor}>
            <div className={classes.topBar}>
                <CallToActionButton display="inline" onClick={handleClosing} text="Close" />
                <CallToActionButton display="inline" onClick={saveNote} text="Save" />
            </div>
            <textarea value={body} onChange={({ target: { value } }) => setBody(value)} className={classes.body} />
        </div>
    )
}
